@for (metric of questionDetails.Metrics; track metric) {
  <app-recommendation-metric class="recommendationMetric" [metric]="metric"
  [therapyRecommendation]="surveyData?.therapy_recommendation?.recommendation"></app-recommendation-metric>
}